import { Injectable } from '@angular/core';
import { VisibaApiHttp } from '../../../Classes/visibaHttp.class';
import { CaseApiModel } from './Models/CaseApiModel';

@Injectable()
export class CasesServiceV2 {
	readonly baseUri = '/api/Client/v2/Cases';

	constructor(private http: VisibaApiHttp) {}

	public get(from: Date | null, to: Date | null, emitLoading = true) {
		const getData = {
			from: from === null ? '' : from.format('yyyy-MM-dd"T"HH:mm'),
			to: to === null ? '' : to.format('yyyy-MM-dd"T"HH:mm'),
		};

		return this.http.getTyped<Array<CaseApiModel>>(`${this.baseUri}`, true, { params: getData }, emitLoading);
	}
}
